document.addEventListener("DOMContentLoaded", function () {
  const blocks = document.querySelectorAll(".image-text");

  blocks.forEach((block) => {
    initializeImageTextPatternReveal(block);
    initializeImageTextFrame(block);
    initializeImageTextVideos(block);
  });
});

document.addEventListener("blockEditorInit", function (event) {
  const block = event.detail.block;

  if (!block) {
    return;
  }

  if (block.matches && block.matches(".image-text")) {
    initializeImageTextPatternReveal(block);
    initializeImageTextFrame(block);
    initializeImageTextVideos(block);
  }

  block.querySelectorAll(".image-text").forEach((imageTextBlock) => {
    initializeImageTextPatternReveal(imageTextBlock);
    initializeImageTextFrame(imageTextBlock);
    initializeImageTextVideos(imageTextBlock);
  });
});

function initializeImageTextVideos(blockElement) {
  blockElement
    .querySelectorAll("[data-image-text-youtube-trigger]")
    .forEach(initializeImageTextYoutubeTrigger);

  blockElement
    .querySelectorAll(".image-text__video-shell--autoplay iframe")
    .forEach(initializeImageTextAutoplayFrame);
}

function initializeImageTextAutoplayFrame(frame) {
  if (frame.dataset.imageTextAutoplayFrameInitialized === "true") {
    return;
  }

  frame.dataset.imageTextAutoplayFrameInitialized = "true";

  frame.addEventListener("load", () => {
    const shell = frame.closest(".image-text__video-shell");

    if (shell) {
      shell.classList.add("is-loaded");
    }
  });

  window.setTimeout(() => {
    const shell = frame.closest(".image-text__video-shell");

    if (shell) {
      shell.classList.add("is-loaded");
    }
  }, 1500);
}

function initializeImageTextYoutubeTrigger(trigger) {
  if (trigger.dataset.imageTextYoutubeTriggerInitialized === "true") {
    return;
  }

  trigger.dataset.imageTextYoutubeTriggerInitialized = "true";

  trigger.addEventListener("click", () => {
    const shell = trigger.closest(".image-text__video-shell");
    const frameWrap = shell?.querySelector("[data-image-text-video-frame]");
    const src = trigger.dataset.videoSrc;

    if (!shell || !frameWrap || !src) {
      return;
    }

    const iframe = document.createElement("iframe");
    iframe.className = "image-text__video-frame";
    iframe.src = src;
    iframe.title = trigger.dataset.videoTitle || "Video";
    iframe.allow =
      "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
    iframe.allowFullscreen = true;
    iframe.referrerPolicy = "strict-origin-when-cross-origin";

    frameWrap.innerHTML = "";
    frameWrap.appendChild(iframe);
    frameWrap.setAttribute("aria-hidden", "false");
    shell.classList.add("is-playing");
  });
}

function initializeImageTextPatternReveal(blockElement) {
  const patternElement = blockElement.querySelector(".section-pattern__image");

  if (!patternElement || blockElement.dataset.imageTextPatternInitialized === "true") {
    return;
  }

  blockElement.dataset.imageTextPatternInitialized = "true";

  if (!("IntersectionObserver" in window)) {
    blockElement.classList.add("image-text--pattern-visible");
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        blockElement.classList.add("image-text--pattern-visible");
        observer.unobserve(entry.target);
      });
    },
    {
      threshold: 0.25,
      rootMargin: "0px 0px -10% 0px",
    },
  );

  observer.observe(blockElement);
}

function initializeImageTextFrame(blockElement) {
  const frameElement = blockElement.querySelector(".image-text__frame");
  const animatedPath = blockElement.querySelector(
    ".image-accordion__frame-animated-path",
  );

  if (
    !frameElement ||
    !animatedPath ||
    blockElement.dataset.imageTextFrameInitialized === "true"
  ) {
    return;
  }

  blockElement.dataset.imageTextFrameInitialized = "true";

  const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;
  let observer = null;
  let revealTimeout = null;

  if (prefersReducedMotion) {
    blockElement.classList.add("image-text--frame-complete");
    return;
  }

  animatedPath.addEventListener("animationend", function (event) {
    if (event.animationName !== "imageTextFrameDraw") {
      return;
    }

    blockElement.classList.remove("image-text--frame-animating");
    blockElement.classList.add("image-text--frame-complete");
  });

  const revealFrame = () => {
    if (
      blockElement.classList.contains("image-text--frame-animating") ||
      blockElement.classList.contains("image-text--frame-complete")
    ) {
      return;
    }

    blockElement.classList.add("image-text--frame-animating");
  };

  if (!("IntersectionObserver" in window)) {
    revealFrame();
    return;
  }

  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (
          blockElement.classList.contains("image-text--frame-animating") ||
          blockElement.classList.contains("image-text--frame-complete")
        ) {
          if (observer) {
            observer.disconnect();
          }
          return;
        }

        if (entry.isIntersecting) {
          if (revealTimeout) {
            return;
          }

          revealTimeout = window.setTimeout(() => {
            revealFrame();

            if (observer) {
              observer.disconnect();
            }

            revealTimeout = null;
          }, 1000);

          return;
        }

        if (revealTimeout) {
          window.clearTimeout(revealTimeout);
          revealTimeout = null;
        }
      });
    },
    {
      threshold: 0.35,
      rootMargin: "0px 0px -10% 0px",
    },
  );

  observer.observe(frameElement);
}
